(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/**
 * Класс исчезающего слайдера
 */
"use strict";
/** Класс активного слайда */
var CLASS_CURRENT = 'current';
var FadeSlideshow = (function () {
    function FadeSlideshow(slideshow, index) {
        if (index === void 0) { index = 0; }
        this.slideshow = slideshow;
        this.index = index;
        this.slidesCollection = slideshow.querySelectorAll('li');
        this.currentIndex = this.index;
        this.buttonPrev = slideshow.querySelector('button.prev');
        this.buttonNext = slideshow.querySelector('button.next');
        this.slidesCollection[this.currentIndex].classList.add(CLASS_CURRENT);
        if (this.slidesCollection.length <= 1) {
            return;
        }
        this.registerHandlers();
    }
    // Регистрация обработчиков
    FadeSlideshow.prototype.registerHandlers = function () {
        var _this = this;
        this.buttonPrev.addEventListener('click', function () { return _this.prev(); });
        this.buttonNext.addEventListener('click', function () { return _this.next(); });
    };
    // Предыдущий слайд
    FadeSlideshow.prototype.prev = function () {
        this.slidesCollection[this.currentIndex].classList.remove(CLASS_CURRENT);
        this.currentIndex--;
        if (this.currentIndex < 0) {
            this.currentIndex = this.slidesCollection.length - 1;
        }
        this.slidesCollection[this.currentIndex].classList.add(CLASS_CURRENT);
    };
    // Следующий слайд
    FadeSlideshow.prototype.next = function () {
        this.slidesCollection[this.currentIndex].classList.remove(CLASS_CURRENT);
        this.currentIndex++;
        if (this.currentIndex >= this.slidesCollection.length) {
            this.currentIndex = 0;
        }
        this.slidesCollection[this.currentIndex].classList.add(CLASS_CURRENT);
    };
    return FadeSlideshow;
}());
exports.default = FadeSlideshow;

},{}],2:[function(require,module,exports){
/** Класс открытия лайтбоксов */
"use strict";
/** Класс активности лайтбокса */
var CLASS_CURRENT = 'current';
var CLASS_HIDE_BUTTONS = 'hide-buttons';
var CLASS_DISABLED = 'disabled';
var CLASS_MOVE = 'move';
var ANIMATE_TIME = 500;
var ShowFadeLightbox = (function () {
    function ShowFadeLightbox(elementCollection, controls) {
        var _this = this;
        this.elementCollection = elementCollection;
        this.controls = controls;
        this.container = this.elementCollection[0].parentNode;
        this.isActive = false;
        /** Для ios дикий костыль, так как он шапку и футер отображает поверх лайтбокса */
        this.main = document.querySelector('body>main');
        if (controls) {
            this.next = controls.querySelector('button.next');
            this.prev = controls.querySelector('button.prev');
            if (this.elementCollection.length > 1) {
                this.prev.addEventListener('click', function () { return _this.slidePrev(); });
                this.next.addEventListener('click', function () { return _this.slideNext(); });
            }
            else {
                controls.classList.add(CLASS_HIDE_BUTTONS);
            }
        }
        window.addEventListener('resize', function () { return _this.goToSlide(); });
    }
    /** открытие лайтбокса */
    ShowFadeLightbox.prototype.open = function (index) {
        this.currentIndex = index;
        this.elementCollection[this.currentIndex].classList.add(CLASS_CURRENT);
        this.container.classList.add(CLASS_CURRENT);
        this.main.classList.add(CLASS_CURRENT);
        this.goToSlide();
        this.controls.style.visibility = 'visible'; // временно, потом вешать класс
        // Событие для пересчёта высоты экрана и отображения в нём влезших элементов
        this.elementCollection[this.currentIndex].dispatchEvent(new CustomEvent('ShowLightbox:open', {
            detail: true,
            bubbles: true
        }));
    };
    /** закрытие лайтбокса */
    ShowFadeLightbox.prototype.close = function () {
        this.elementCollection[this.currentIndex].classList.remove(CLASS_CURRENT);
        this.container.classList.remove(CLASS_CURRENT);
        this.main.classList.remove(CLASS_CURRENT);
        this.controls.style.visibility = ''; // временно, потом вешать класс
        this.next.classList.remove(CLASS_DISABLED);
        this.prev.classList.remove(CLASS_DISABLED);
        // Событие для пересчёта высоты экрана и отображения в нём влезших элементов
        this.elementCollection[this.currentIndex].dispatchEvent(new CustomEvent('ShowLightbox:close', {
            detail: true,
            bubbles: true
        }));
    };
    /** переключить слайд */
    ShowFadeLightbox.prototype.goToSlide = function () {
        if (!this.container.classList.contains(CLASS_CURRENT)) {
            return;
        }
        if (this.currentIndex >= this.elementCollection.length - 1) {
            this.next.classList.add(CLASS_DISABLED);
        }
        if (this.currentIndex <= 0) {
            this.prev.classList.add(CLASS_DISABLED);
        }
        var asideId = this.elementCollection[this.currentIndex].querySelector('aside').id;
        window.location.hash = asideId; // изменение хеша при смене лайтбокса
        // custom для того, чтобы пропадали кнопки при перелистывании и потом появлялись
        // if ( this.controls.contains( event.target as HTMLElement ) )
        // {
        // 	this.container.parentElement.classList.add( CLASS_HIDE_BUTTONS );
        // 	setTimeout( () => this.container.parentElement.classList.remove( CLASS_HIDE_BUTTONS ), ANIMATE_TIME );
        // }
    };
    /** следующий слайд */
    ShowFadeLightbox.prototype.slideNext = function () {
        var _this = this;
        if (!this.isActive) {
            if (this.currentIndex < this.elementCollection.length - 1) {
                this.elementCollection[this.currentIndex].classList.remove(CLASS_CURRENT);
                this.currentIndex++;
                this.goToSlide();
                this.isActive = true;
                setTimeout(function () { return _this.isActive = false; }, ANIMATE_TIME);
                // this.container.classList.add( CLASS_MOVE );
                // setTimeout( () => this.container.classList.remove( CLASS_MOVE ), ANIMATE_TIME );
                /*if ( this.currentIndex >= this.elementCollection.length - 1 )
                {
                    this.elementCollection[this.currentIndex] = this.elementCollection[this.elementCollection.length - 1];
                    this.currentIndex = this.elementCollection.length - 1;
                    this.next.classList.add( CLASS_DISABLED );
                }
                else
                {
                    this.next.classList.remove( CLASS_DISABLED );
                }*/
                if (this.prev.classList.contains(CLASS_DISABLED)) {
                    this.prev.classList.remove(CLASS_DISABLED);
                }
                this.elementCollection[this.currentIndex].classList.add(CLASS_CURRENT);
            }
        }
    };
    /** предыдущий слайд */
    ShowFadeLightbox.prototype.slidePrev = function () {
        var _this = this;
        if (!this.isActive) {
            if (this.currentIndex > 0) {
                this.elementCollection[this.currentIndex].classList.remove(CLASS_CURRENT);
                this.currentIndex--;
                this.goToSlide();
                this.isActive = true;
                setTimeout(function () { return _this.isActive = false; }, ANIMATE_TIME);
                // this.container.classList.add( CLASS_MOVE );
                // setTimeout( () => this.container.classList.remove( CLASS_MOVE ), ANIMATE_TIME );
                /*if ( this.currentIndex <= 0 )
                {
                    this.elementCollection[this.currentIndex] = this.elementCollection[0];
                    this.currentIndex = 0;
                    this.prev.classList.add( CLASS_DISABLED );
                }
                else
                {
                    this.prev.classList.remove( CLASS_DISABLED );
                }*/
                if (this.next.classList.contains(CLASS_DISABLED)) {
                    this.next.classList.remove(CLASS_DISABLED);
                }
                this.elementCollection[this.currentIndex].classList.add(CLASS_CURRENT);
            }
        }
    };
    return ShowFadeLightbox;
}());
exports.default = ShowFadeLightbox;

},{}],3:[function(require,module,exports){
"use strict";
require('./../lib/polyfills/Element.closest');
require('./../lib/polyfills/CustomEvent');
// import iOsHoverFix from './modules/iOsHoverFix';
var map_1 = require('./modules/map');
var scrollScreen_1 = require('./modules/scrollScreen');
var scrollScreenInsidePages_1 = require('./modules/scrollScreenInsidePages');
var fadeSlideshow_1 = require('./modules/fadeSlideshow');
var secondSlideshow_1 = require('./modules/secondSlideshow');
var activities_1 = require('./modules/activities');
var news_1 = require('./modules/news');
var vacancies_1 = require('./modules/vacancies');
var subscribeVacancies_1 = require('./modules/subscribeVacancies');
var language_1 = require('./modules/language');
var search_1 = require('./modules/search');
// iOsHoverFix();
map_1.default();
scrollScreen_1.default();
fadeSlideshow_1.default();
secondSlideshow_1.default();
scrollScreenInsidePages_1.default();
activities_1.default();
news_1.default();
vacancies_1.default();
subscribeVacancies_1.default();
language_1.default();
search_1.default();

},{"./../lib/polyfills/CustomEvent":18,"./../lib/polyfills/Element.closest":19,"./modules/activities":4,"./modules/fadeSlideshow":6,"./modules/language":7,"./modules/map":8,"./modules/news":9,"./modules/scrollScreen":10,"./modules/scrollScreenInsidePages":11,"./modules/search":12,"./modules/secondSlideshow":13,"./modules/subscribeVacancies":14,"./modules/vacancies":15}],4:[function(require,module,exports){
"use strict";
var ShowFadeLightbox_1 = require('../classes/ShowFadeLightbox');
var scrollElementTo_1 = require('../../lib/utils/animation/scrollElementTo');
/** Обозначение кнопки esc */
var VK_ESC = 27;
var SCREEN_WIDTH_SMALL = 980;
var isOpenedLightbox = false;
var scrollState = 0;
function main() {
    var container = document.querySelector('main.activities');
    if (!container) {
        return;
    }
    var listElementsContainer = container.querySelector('ul.activities');
    registerHandlers(listElementsContainer);
}
exports.default = main;
function registerHandlers(listElementsContainer) {
    Array.prototype.forEach.call(listElementsContainer.children, function (item) {
        var subContainer = item.querySelector('ul');
        var controls = item.querySelector('div.controls');
        var buttonClose = controls.querySelector('button.close');
        var subCollection = [];
        Array.prototype.filter.call(subContainer.children, function (item) {
            if (!item.getAttribute('aria-disabled')) {
                subCollection.push(item);
            }
        });
        var showFadeLightbox;
        var unRegisterHandlers;
        if (subContainer.children.length > 0) {
            showFadeLightbox = new ShowFadeLightbox_1.default(subCollection, controls);
        }
        /** Клик мимо */
        var boundDocumentClickHandler = function (event) {
            if (event.target.classList.contains('lightbox')) {
                event.stopPropagation();
                closeLightbox(showFadeLightbox, unRegisterHandlers);
            }
        };
        /** нажатие esc */
        var boundDocumentKeyupHandler = function (event) {
            if (event.keyCode === VK_ESC) {
                closeLightbox(showFadeLightbox, unRegisterHandlers);
            }
        };
        unRegisterHandlers = function () {
            document.removeEventListener('click', boundDocumentClickHandler, true);
            document.removeEventListener('keyup', boundDocumentKeyupHandler, true);
        };
        buttonClose.addEventListener('click', function (event) {
            event.stopPropagation();
            closeLightbox(showFadeLightbox, unRegisterHandlers);
        });
        Array.prototype.forEach.call(subCollection, function (subItem, index) {
            registerHandlersLightbox(showFadeLightbox, subItem, index, boundDocumentClickHandler, boundDocumentKeyupHandler);
        });
        // Событие по закрытию лайтбокса
        listElementsContainer.addEventListener('ShowLightbox:close', function () {
            installScrollHeight();
        });
    });
}
function registerHandlersLightbox(showFadeLightbox, subItem, index, handlerClick, handlerEsc) {
    var asideId = subItem.querySelector('aside').id;
    subItem.addEventListener('click', function () {
        openLightbox(showFadeLightbox, index, handlerClick, handlerEsc);
    });
    if (window.location.hash === "#" + asideId) {
        openLightbox(showFadeLightbox, index, handlerClick, handlerEsc);
    }
}
/** открыть лайтбокс */
function openLightbox(lightbox, index, handlerClick, handlerEsc) {
    if (!isOpenedLightbox) {
        scrollState = window.pageYOffset;
        lightbox.open(index);
        document.addEventListener('click', handlerClick, true);
        document.addEventListener('keyup', handlerEsc, true);
        isOpenedLightbox = true;
    }
}
/** закрыть лайтбокс */
function closeLightbox(lightbox, unRegisterHandlers) {
    if (isOpenedLightbox) {
        lightbox.close();
        unRegisterHandlers();
        window.location.hash = '';
        isOpenedLightbox = false;
    }
}
function installScrollHeight() {
    if (isModeMobile()) {
        scrollElementTo_1.default(window, scrollState, 10);
    }
}
function isModeMobile() {
    return (window.innerWidth < SCREEN_WIDTH_SMALL);
}

},{"../../lib/utils/animation/scrollElementTo":22,"../classes/ShowFadeLightbox":2}],5:[function(require,module,exports){
"use strict";
var CLASS_PUT_UP_HEIGHT = 'put-up-height';
function main(collection) {
    if (collection[0].parentElement.classList.contains(CLASS_PUT_UP_HEIGHT)) {
        collection[0].parentElement.classList.remove(CLASS_PUT_UP_HEIGHT);
    }
    var maxHeight = 0;
    collection[0].parentElement.style.height = '';
    for (var i = 0; i < collection.length; i++) {
        if (maxHeight < collection[i].offsetHeight) {
            maxHeight = collection[i].offsetHeight;
            collection[i].parentElement.style.height = maxHeight + 'px';
        }
    }
    collection[0].parentElement.classList.add(CLASS_PUT_UP_HEIGHT);
}
exports.default = main;

},{}],6:[function(require,module,exports){
"use strict";
var calcHeight_1 = require('./calcHeight');
var FadeSlideshow_1 = require('../classes/FadeSlideshow');
function main() {
    var historySlideshow = document.querySelector('div.history-slideshow');
    if (!historySlideshow) {
        return;
    }
    new FadeSlideshow_1.default(historySlideshow);
    var slidesCollection = historySlideshow.querySelectorAll('ul.slides>li');
    if (slidesCollection) {
        calcHeight_1.default(slidesCollection);
        window.addEventListener('resize', function () { return calcHeight_1.default(slidesCollection); });
    }
}
exports.default = main;

},{"../classes/FadeSlideshow":1,"./calcHeight":5}],7:[function(require,module,exports){
"use strict";
var SCREEN_WIDTH_SMALL = 980;
var CLASS_OPENED = 'opened';
var CLASS_RESET_CLICK = 'reset-click';
var isOpen = false;
function main() {
    var container = document.querySelector('header>div.container>ul.languages');
    if (!container) {
        return;
    }
    /** нажатие на кнопку мыши */
    var documentClickHandler = function (event) {
        close(event, container);
        document.body.classList.remove(CLASS_RESET_CLICK);
        document.removeEventListener('click', documentClickHandler, true);
    };
    container.addEventListener('click', function (event) { return open(event, container, documentClickHandler); });
}
exports.default = main;
function open(event, container, documentClickHandler) {
    if (isModeMobile()) {
        if (!isOpen) {
            container.classList.add(CLASS_OPENED);
            isOpen = true;
            document.body.classList.add(CLASS_RESET_CLICK);
            document.addEventListener('click', documentClickHandler, true);
        }
        else {
            if (event.target !== container) {
                close(event, container);
            }
        }
    }
    else {
        close(event, container);
    }
}
function close(event, container) {
    container.classList.remove(CLASS_OPENED);
    isOpen = false;
}
function isModeMobile() {
    return (window.innerWidth < SCREEN_WIDTH_SMALL);
}

},{}],8:[function(require,module,exports){
"use strict";
var Map_1 = require('../../lib/GoogleMaps/Map');
var throttle_1 = require('../../lib/utils/events/throttle');
require('../../lib/GoogleMaps/InfoBox');
var CLASS_LOCATION_CURRENT = 'current';
var MARKERS_SIZE = 60;
// const currentElementCollection: {[index: string]: Fields} = Object.create( null );
var currentElementCollection = Object.create(null);
function init() {
    var map;
    var mapElement;
    var options;
    var styles = [
        {
            "featureType": "all",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": -100
                },
                {
                    "gamma": 0.5
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        }
    ];
    mapElement = document.querySelector('div[data-map]');
    if (!mapElement) {
        return;
    }
    options = JSON.parse(mapElement.dataset['map']);
    if (!options.center) {
        return;
    }
    map = new Map_1.default(mapElement, function () { return ({
        // координаты офиса
        // center: new google.maps.LatLng(59.941998, 30.256874),
        // координаты порта
        center: new google.maps.LatLng(59.903194, 30.234266),
        zoom: 14,
        scrollwheel: false,
        streetViewControl: false,
        panControl: false,
        zoomControl: false,
        disableDoubleClickZoom: false,
        mapTypeControl: false,
        navigationControl: false,
        overviewMapControl: false,
        rotateControl: false,
        scaleControl: false
    }); }, function () {
        var infoBox;
        infoBox = Map_1.default.plugin('InfoBox', 'Test info box');
        infoBox.sayHello();
        map.map.setOptions({ styles: styles });
        mapInitialized(map);
    });
    window.addEventListener('resize', throttle_1.default(function () {
        map.resize();
    }));
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = init;
function mapInitialized(map) {
    var container = document.querySelector('main>div.tabs-places');
    var streets = container.querySelectorAll('ul.places>li>a');
    var currentElements = container.querySelectorAll('ul>li.current');
    addGroundOverlay(map);
    Array.prototype.forEach.call(currentElements, function (item) {
        currentElementCollection[item.dataset['name']] = item;
    });
    Array.prototype.forEach.call(streets, function (element) {
        var coordinates;
        coordinates = getCoordinates(element.href);
        element.addEventListener('click', function (event) { return jump(event, element, coordinates, map); });
        marker(map, coordinates, element.textContent);
    });
}
function getCoordinates(uri) {
    var pattern;
    var matches;
    pattern = /@([\d.]+),([\d.]+),/;
    matches = uri.match(pattern);
    if (matches) {
        return new google.maps.LatLng(Number(matches[1]), Number(matches[2]));
    }
    else {
        return null;
    }
}
function jump(event, element, coordinates, map) {
    event.preventDefault();
    if (!element.parentElement.classList.contains(CLASS_LOCATION_CURRENT)) {
        currentElementCollection['place'].classList.remove(CLASS_LOCATION_CURRENT);
        delete currentElementCollection['place'];
        map.map.panTo(coordinates);
        element.parentElement.classList.add(CLASS_LOCATION_CURRENT);
        currentElementCollection['place'] = element.parentElement;
    }
}
function marker(map, coordinates, title) {
    var marker;
    marker = new google.maps.Marker({
        position: coordinates,
        map: map.map,
        icon: {
            url: '/images/map/marker.png',
            size: new google.maps.Size(MARKERS_SIZE, MARKERS_SIZE),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(20, 52)
        },
        clickable: true,
        title: title
    });
}
function addGroundOverlay(map) {
    var imageBounds;
    var image = '/images/map/port_shape.svg';
    imageBounds = new google.maps.LatLngBounds(new google.maps.LatLng(59.902109, 30.230866), new google.maps.LatLng(59.903526, 30.234948));
    new google.maps.GroundOverlay(image, imageBounds, {
        clickable: false,
        map: map.map
    });
}

},{"../../lib/GoogleMaps/InfoBox":16,"../../lib/GoogleMaps/Map":17,"../../lib/utils/events/throttle":24}],9:[function(require,module,exports){
"use strict";
var ShowFadeLightbox_1 = require('../classes/ShowFadeLightbox');
var scrollElementTo_1 = require('../../lib/utils/animation/scrollElementTo');
/** Обозначение кнопки esc */
var VK_ESC = 27;
var SCREEN_WIDTH_SMALL = 980;
var isOpenedLightbox = false;
var scrollState = 0;
function main() {
    var container = document.querySelector('main.news');
    if (!container) {
        return;
    }
    var listElementsContainer = container.querySelector('ul.news');
    var controls = container.querySelector('div.controls');
    var buttonClose = controls.querySelector('button.close');
    var showFadeLightbox;
    var unRegisterHandlers;
    if (listElementsContainer.children.length > 0) {
        showFadeLightbox = new ShowFadeLightbox_1.default(listElementsContainer.children, controls);
    }
    /** Клик мимо */
    var boundDocumentClickHandler = function (event) {
        if (event.target.classList.contains('lightbox')) {
            event.stopPropagation();
            closeLightbox(showFadeLightbox, unRegisterHandlers);
        }
    };
    /** нажатие esc */
    var boundDocumentKeyupHandler = function (event) {
        if (event.keyCode === VK_ESC) {
            closeLightbox(showFadeLightbox, unRegisterHandlers);
        }
    };
    unRegisterHandlers = function () {
        document.removeEventListener('click', boundDocumentClickHandler, true);
        document.removeEventListener('keyup', boundDocumentKeyupHandler, true);
    };
    buttonClose.addEventListener('click', function (event) {
        event.stopPropagation();
        closeLightbox(showFadeLightbox, unRegisterHandlers);
    });
    Array.prototype.forEach.call(listElementsContainer.children, function (item, index) {
        registerHandlersLightbox(showFadeLightbox, item, index, boundDocumentClickHandler, boundDocumentKeyupHandler);
    });
    // Событие по закрытию лайтбокса
    listElementsContainer.addEventListener('ShowLightbox:close', function () {
        installScrollHeight();
    });
}
exports.default = main;
function registerHandlersLightbox(showFadeLightbox, item, index, handlerClick, handlerEsc) {
    var asideId = item.querySelector('aside').id;
    item.addEventListener('click', function () {
        openLightbox(showFadeLightbox, index, handlerClick, handlerEsc);
    }, true);
    if (window.location.hash === "#" + asideId) {
        openLightbox(showFadeLightbox, index, handlerClick, handlerEsc);
    }
}
/** открыть лайтбокс */
function openLightbox(lightbox, index, handlerClick, handlerEsc) {
    if (!isOpenedLightbox) {
        scrollState = window.pageYOffset;
        lightbox.open(index);
        document.addEventListener('click', handlerClick, true);
        document.addEventListener('keyup', handlerEsc, true);
        isOpenedLightbox = true;
    }
}
/** закрыть лайтбокс */
function closeLightbox(lightbox, unRegisterHandlers) {
    if (isOpenedLightbox) {
        lightbox.close();
        unRegisterHandlers();
        window.location.hash = '';
        isOpenedLightbox = false;
    }
}
function installScrollHeight() {
    if (isModeMobile()) {
        scrollElementTo_1.default(window, scrollState, 10);
    }
}
function isModeMobile() {
    return (window.innerWidth < SCREEN_WIDTH_SMALL);
}

},{"../../lib/utils/animation/scrollElementTo":22,"../classes/ShowFadeLightbox":2}],10:[function(require,module,exports){
"use strict";
var scrollElementTo_1 = require('../../lib/utils/animation/scrollElementTo');
var debounce_1 = require('../../lib/utils/events/debounce');
var SCREEN_WIDTH_SMALL = 980;
var CLASS_CURRENT = 'current';
// скорость прокрутки страницы
var animateTime = 1000;
// состояние прокрутки страницы
var scrollState = 0;
// высота экрана
var screenHeight;
// активна ли прокрутка?
var isActiveScroll = false;
// сколько раз прокрутился экран
var countScroll = 0;
// сколько экранов вмещается на странице
var countScreenOnPage = 0;
// массив с элементами навигации
var arrayNavigationMenuElements = [];
// Кнопка прокрутки вниз
var buttonScrollBottom;
// инициализация
function main() {
    var main = document.querySelector('body>main');
    if (!main
        || !document.body.classList.contains('index')
        || document.documentElement.classList.contains('ua-mobile')) {
        return;
    }
    // состояние прокрутки при загрузке страницы
    scrollState = window.pageYOffset;
    // элементы для скролла
    var scrollElementCollection = main.querySelectorAll('div.screen-container');
    var navigateMenuContainer = document.querySelector('main>aside.navigation>div.scroll-container>ul.navigation');
    registerHandlers(scrollElementCollection, navigateMenuContainer);
}
exports.default = main;
// регистрация обработчиков
function registerHandlers(scrollElementCollection, navigateMenuContainer) {
    var boundDocumentClickHandler = function (event) { return targetClick(event); };
    var boundDocumentScrollHandler = debounce_1.default(function (event) { return targetScroll(scrollElementCollection, event); }, 100, true);
    // const boundDocumentScrollHandler: ( event: WheelEvent ) => void =
    // 		debounce( targetScroll.bind( null, scrollElementCollection ), 100, true );
    var unRegisterHandlers = function () {
        buttonScrollBottom.removeEventListener('click', boundDocumentClickHandler);
        window.removeEventListener('wheel', boundDocumentScrollHandler);
    };
    // высота экрана
    screenHeight = updateResizeVariables(scrollElementCollection, navigateMenuContainer, boundDocumentClickHandler, boundDocumentScrollHandler, unRegisterHandlers);
    window.addEventListener('resize', function () {
        return updateResizeVariables(scrollElementCollection, navigateMenuContainer, boundDocumentClickHandler, boundDocumentScrollHandler, unRegisterHandlers);
    });
}
// пересчёт переменных при ресайзе окна
function updateResizeVariables(scrollElementCollection, navigateMenuContainer, boundDocumentClickHandler, boundDocumentScrollHandler, unRegisterHandlers) {
    if (!isModeMobile()) {
        countScreenOnPage = scrollElementCollection.length;
        screenHeight = document.documentElement.clientHeight;
        countScroll = Math.round(window.pageYOffset / screenHeight);
        scrollState = countScroll * screenHeight;
        if (arrayNavigationMenuElements.length <= 0) {
            createdNavigationMenu(navigateMenuContainer, countScreenOnPage, boundDocumentClickHandler);
            arrayNavigationMenuElements[countScroll].classList.add(CLASS_CURRENT);
        }
        if (countScroll === (countScreenOnPage - 1)) {
            addClassButtonScrollBottom(buttonScrollBottom);
        }
        // Вешаю обработчик на колесо мыши, оборачиваю в функцию для того, чтобы убирать инерцию от скролла
        window.addEventListener('wheel', boundDocumentScrollHandler);
        scrollElementTo_1.default(window, scrollState, 10);
    }
    else {
        removeChildNavigationMenu(arrayNavigationMenuElements, navigateMenuContainer);
        var parentNavigateMenuContainer = navigateMenuContainer.closest('aside.navigation');
        // Если есть, то удалить
        if (parentNavigateMenuContainer.contains(buttonScrollBottom)) {
            console.log('mobile');
            unRegisterHandlers();
            parentNavigateMenuContainer.removeChild(buttonScrollBottom);
        }
    }
    return screenHeight;
}
// создание меню навигации
function createdNavigationMenu(navigateMenuContainer, countScreenOnPage, boundDocumentClickHandler) {
    for (var i = 0; i < countScreenOnPage; i++) {
        var bulitElement = document.createElement('a');
        var bulitElementContainer = document.createElement('li');
        bulitElement.addEventListener('click', function (event) { return targetClick(event); });
        arrayNavigationMenuElements.push(bulitElementContainer);
        bulitElementContainer.appendChild(bulitElement);
        navigateMenuContainer.appendChild(bulitElementContainer);
    }
    // Создание элемента button ( кнопки прокрутки вниз )
    var button = document.createElement('button');
    button.classList.add('scroll-bottom');
    button.textContent = 'Показать ещё';
    button.addEventListener('click', boundDocumentClickHandler);
    buttonScrollBottom = button;
    var parentNavigateMenuContainer = navigateMenuContainer.closest('aside.navigation');
    parentNavigateMenuContainer.appendChild(buttonScrollBottom);
    return navigateMenuContainer;
}
// срабатывает при скролле колесом мыши
function targetScroll(scrollElementCollection, event) {
    event.preventDefault();
    if (isActiveScroll
        || (event.deltaY === 0)) {
        return;
    }
    if (event.deltaY > 0) {
        if (scrollState < (scrollElementCollection.length - 1) * screenHeight) {
            isActiveScroll = true;
            scrollState += screenHeight;
            addClassButtonScrollBottom(buttonScrollBottom);
            arrayNavigationMenuElements[countScroll].classList.remove(CLASS_CURRENT);
            countScroll++;
            arrayNavigationMenuElements[countScroll].classList.add(CLASS_CURRENT);
            if (countScroll !== (countScreenOnPage - 1)) {
                setTimeout(function () { return removeClassButtonScrollBottom(buttonScrollBottom); }, animateTime);
            }
            toScroll(scrollState);
        }
        else {
            scrollState = (scrollElementCollection.length - 1) * screenHeight;
        }
    }
    else if (event.deltaY > -screenHeight) {
        if (scrollState > 0) {
            isActiveScroll = true;
            scrollState -= screenHeight;
            addClassButtonScrollBottom(buttonScrollBottom);
            setTimeout(function () { return removeClassButtonScrollBottom(buttonScrollBottom); }, animateTime);
            arrayNavigationMenuElements[countScroll].classList.remove(CLASS_CURRENT);
            countScroll--;
            arrayNavigationMenuElements[countScroll].classList.add(CLASS_CURRENT);
            toScroll(scrollState);
        }
        else {
            scrollState = 0;
        }
    }
}
// срабатывает при клике
function targetClick(event) {
    if (isActiveScroll) {
        return;
    }
    isActiveScroll = true;
    if (event.target === buttonScrollBottom) {
        scrollState += screenHeight;
        addClassButtonScrollBottom(buttonScrollBottom);
        arrayNavigationMenuElements[countScroll].classList.remove(CLASS_CURRENT);
        countScroll++;
        arrayNavigationMenuElements[countScroll].classList.add(CLASS_CURRENT);
        if (countScroll !== (countScreenOnPage - 1)) {
            setTimeout(function () { return removeClassButtonScrollBottom(buttonScrollBottom); }, animateTime);
        }
    }
    else {
        var element = event.target;
        var index = arrayNavigationMenuElements.indexOf(element.parentElement);
        scrollState = screenHeight * index;
        addClassButtonScrollBottom(buttonScrollBottom);
        arrayNavigationMenuElements[countScroll].classList.remove(CLASS_CURRENT);
        countScroll = index;
        arrayNavigationMenuElements[countScroll].classList.add(CLASS_CURRENT);
        if (index !== arrayNavigationMenuElements.length - 1) {
            setTimeout(function () { return removeClassButtonScrollBottom(buttonScrollBottom); }, animateTime);
        }
    }
    toScroll(scrollState);
}
// скролит страницу на заданную величину
function toScroll(scrollState) {
    scrollElementTo_1.default(window, scrollState, animateTime);
    setTimeout(function () {
        isActiveScroll = false;
    }, animateTime);
}
// Удаление элементов в массиве
function removeChildNavigationMenu(array, container) {
    array.forEach(function (item) {
        container.removeChild(item);
    });
    array.length = 0;
}
// Добавление класса кнопки прокрутки вниз
function addClassButtonScrollBottom(button) {
    button.classList.add('hide');
}
// Удаление класса кнопки прокрутки вниз
function removeClassButtonScrollBottom(button) {
    button.classList.remove('hide');
}
function isModeMobile() {
    return (window.innerWidth < SCREEN_WIDTH_SMALL);
}

},{"../../lib/utils/animation/scrollElementTo":22,"../../lib/utils/events/debounce":23}],11:[function(require,module,exports){
"use strict";
var scrollElementTo_1 = require('../../lib/utils/animation/scrollElementTo');
var debounce_1 = require('../../lib/utils/events/debounce');
var SCREEN_WIDTH_SMALL = 980;
var PADDING_ALL_SCREEN_HEIGHT = 260;
var CLASS_CURRENT = 'current';
var CLASS_SCREEN = 'screen';
var CLASS_MOVE = 'move';
// скорость прокрутки страницы
var animateTime = 1000;
var animateTimeHide = 600;
// высота экрана
var screenHeight;
// Количество экранов
var screenCount = 0;
// запущен ли скрипт скролла страницы по экранам
var listElementsMargin = [];
// массив с элементами навигации
var arrayNavigationMenuElements = [];
// активна ли прокрутка?
var isActiveScroll = false;
// состояние прокрутки страницы
var scrollState = 0;
// массив высот всех элементов
var arrayHeightElements = [];
// сколько раз прокрутился экран
var countScroll = 0;
// Высоты контейнера
var heightContainer = 0;
// Кнопка прокрутки вниз
var buttonScrollBottom;
var storeHeight = 0;
var heightElement = 0;
// инициализация
function main() {
    var main = document.querySelector('body>main');
    // Проверка на соответствующие страницы
    if (!main
        || document.body.classList.contains('index')
        || document.body.classList.contains('contacts')
        || document.body.classList.contains('error')
        || document.body.classList.contains('main')
        || document.body.classList.contains('search')
        || document.documentElement.classList.contains('ua-mobile')) {
        return;
    }
    // Контейнер с элементами
    var containerElements = main.querySelector('main>ul');
    if (!containerElements) {
        return;
    }
    // Контейнер меню навигации
    var navigateMenuContainer = document.querySelector('main>aside.navigation>div.scroll-container>ul.navigation');
    // Заголовок сверху страницы
    var title = main.querySelector('h2');
    scrollState = window.pageYOffset;
    registerHandlers(main, containerElements, title, navigateMenuContainer);
}
exports.default = main;
// регистрация обработчиков
function registerHandlers(main, containerElements, title, navigateMenuContainer) {
    var boundDocumentClickHandler = function (event) {
        return targetClick(event, main);
    };
    var boundDocumentScrollHandler = debounce_1.default(function (event) { return targetScroll(main, navigateMenuContainer, event); }, 100, true);
    var unRegisterHandlers = function () {
        buttonScrollBottom.removeEventListener('click', boundDocumentClickHandler);
        window.removeEventListener('wheel', boundDocumentScrollHandler);
    };
    screenHeight = updateResizeVariables(main, containerElements, title, navigateMenuContainer, boundDocumentScrollHandler, boundDocumentClickHandler, unRegisterHandlers);
    // Событие по открытию лайтбокса
    containerElements.addEventListener('ShowLightbox:open', function () {
        clearHeightContainer(containerElements);
    });
    // Событие по закрытию лайтбокса
    window.addEventListener('ShowLightbox:close', function () {
        installScrollHeight(containerElements);
    });
    window.addEventListener('resize', function () { return updateResizeVariables(main, containerElements, title, navigateMenuContainer, boundDocumentScrollHandler, boundDocumentClickHandler, unRegisterHandlers); });
}
// пересчёт переменных при ресайзе окна
function updateResizeVariables(main, containerElements, title, navigateMenuContainer, boundDocumentScrollHandler, boundDocumentClickHandler, unRegisterHandlers) {
    if (!isModeMobile()) {
        // Высота заголовка
        var titleHeight = title.offsetHeight;
        // Размер нижнего отступа у заголовка
        var titleMarginBottom = window.getComputedStyle(title).marginBottom;
        // Сумма высоты заголовка и нижнего отступа
        var titleAllHeight = titleHeight + parseInt(titleMarginBottom);
        // Высота экрана без высот шапки и футера
        screenHeight = document.documentElement.clientHeight - PADDING_ALL_SCREEN_HEIGHT;
        // Очищаю массив
        arrayHeightElements.length = 0;
        if (!containerElements.classList.contains(CLASS_CURRENT)) {
            // Проверка на заполненность массива с элементами с отступом и очищение его
            if (listElementsMargin.length >= 1) {
                clearArray();
                removeChildNavigationMenu(arrayNavigationMenuElements, navigateMenuContainer);
                // Если есть, то удалить
                if (buttonScrollBottom) {
                    unRegisterHandlers();
                    var parentNavigateMenuContainer = navigateMenuContainer.closest('aside.navigation');
                    parentNavigateMenuContainer.removeChild(buttonScrollBottom);
                }
            }
            // Если класс есть на контейнере, то удалить его
            if (main.classList.contains(CLASS_SCREEN)) {
                main.classList.remove(CLASS_SCREEN);
            }
            // Вызов функции разделения страницы на экраны
            initScroll(main, containerElements, titleAllHeight, navigateMenuContainer, boundDocumentScrollHandler, boundDocumentClickHandler);
        }
        // Если прокрутка равна 0, то шаг прокрутки 0
        if (window.pageYOffset === 0) {
            countScroll = 0;
        }
        else {
            // Если прокрутка больше 0, то высчитывается шаг прокрутки
            countScroll = window.pageYOffset / document.documentElement.clientHeight;
        }
        // Округление( на всякий случай )
        countScroll = Math.round(countScroll);
        // countScroll = 3;
        // Высчитываю состояние прокрутки
        scrollState = countScroll * document.documentElement.clientHeight;
        // Функция плавной прокрутки
        scrollElementTo_1.default(window, scrollState, 10);
        // Если есть элемент в массиве с индексом
        if (arrayNavigationMenuElements[countScroll]) {
            arrayNavigationMenuElements[countScroll].classList.add(CLASS_CURRENT);
            if (countScroll === (screenCount - 1)) {
                addClassButtonScrollBottom(buttonScrollBottom);
            }
        }
        else {
            scrollElementTo_1.default(window, 0, 1000);
        }
    }
    else {
        containerElements.style.height = '';
        main.classList.remove(CLASS_SCREEN);
        if (listElementsMargin.length >= 1) {
            clearArray();
            removeChildNavigationMenu(arrayNavigationMenuElements, navigateMenuContainer);
            // Если есть, то удалить
            if (buttonScrollBottom) {
                unRegisterHandlers();
                var parentNavigateMenuContainer = navigateMenuContainer.closest('aside.navigation');
                parentNavigateMenuContainer.removeChild(buttonScrollBottom);
            }
        }
    }
    return screenHeight;
}
// срабатывает при скролле колесом мыши
function targetScroll(main, navigateMenuContainer, event) {
    // Активна ли прокрутка
    if (isActiveScroll
        || (event.deltaY === 0)
        || event.target.closest('ul.current')
        || event.target.closest('div.controls')) {
        return;
    }
    if (navigateMenuContainer.contains(event.target)) {
        event.preventDefault();
        return;
    }
    event.preventDefault();
    // Направление прокрутки
    if (event.deltaY >= 0) {
        if (scrollState < (screenCount - 1) * (screenHeight + PADDING_ALL_SCREEN_HEIGHT)) {
            isActiveScroll = true;
            scrollState += (screenHeight + PADDING_ALL_SCREEN_HEIGHT);
            if (arrayNavigationMenuElements[countScroll]) {
                addClassButtonScrollBottom(buttonScrollBottom);
                arrayNavigationMenuElements[countScroll].classList.remove(CLASS_CURRENT);
                countScroll++;
                arrayNavigationMenuElements[countScroll].classList.add(CLASS_CURRENT);
                if (countScroll !== (screenCount - 1)) {
                    setTimeout(function () { return removeClassButtonScrollBottom(buttonScrollBottom); }, animateTimeHide);
                }
            }
            main.classList.add(CLASS_MOVE);
            setTimeout(function () { return main.classList.remove(CLASS_MOVE); }, animateTimeHide);
            toScroll(scrollState);
        }
        else {
            scrollState = (screenCount - 1) * (screenHeight + PADDING_ALL_SCREEN_HEIGHT);
        }
    }
    else if (event.deltaY >= -(screenHeight + PADDING_ALL_SCREEN_HEIGHT)) {
        if (scrollState > 0) {
            isActiveScroll = true;
            scrollState -= (screenHeight + PADDING_ALL_SCREEN_HEIGHT);
            if (arrayNavigationMenuElements[countScroll]) {
                addClassButtonScrollBottom(buttonScrollBottom);
                setTimeout(function () { return removeClassButtonScrollBottom(buttonScrollBottom); }, animateTimeHide);
                arrayNavigationMenuElements[countScroll].classList.remove(CLASS_CURRENT);
                countScroll--;
                arrayNavigationMenuElements[countScroll].classList.add(CLASS_CURRENT);
            }
            main.classList.add(CLASS_MOVE);
            setTimeout(function () { return main.classList.remove(CLASS_MOVE); }, animateTimeHide);
            toScroll(scrollState);
        }
        else {
            scrollState = 0;
        }
    }
}
// срабатывает при клике
function targetClick(event, main) {
    if (isActiveScroll
        || event.target.closest('ul.current')) {
        return;
    }
    if (event.target === buttonScrollBottom) {
        isActiveScroll = true;
        scrollState += (screenHeight + PADDING_ALL_SCREEN_HEIGHT);
        if (arrayNavigationMenuElements[countScroll]) {
            addClassButtonScrollBottom(buttonScrollBottom);
            arrayNavigationMenuElements[countScroll].classList.remove(CLASS_CURRENT);
            countScroll++;
            arrayNavigationMenuElements[countScroll].classList.add(CLASS_CURRENT);
            if (countScroll !== (screenCount - 1)) {
                setTimeout(function () { return removeClassButtonScrollBottom(buttonScrollBottom); }, animateTimeHide);
            }
        }
    }
    else {
        isActiveScroll = true;
        var element = event.target;
        var index = arrayNavigationMenuElements.indexOf(element.parentElement);
        scrollState = (screenHeight + PADDING_ALL_SCREEN_HEIGHT) * index;
        if (arrayNavigationMenuElements[countScroll]) {
            addClassButtonScrollBottom(buttonScrollBottom);
            arrayNavigationMenuElements[countScroll].classList.remove(CLASS_CURRENT);
            countScroll = index;
            arrayNavigationMenuElements[countScroll].classList.add(CLASS_CURRENT);
            if (index !== arrayNavigationMenuElements.length - 1) {
                setTimeout(function () { return removeClassButtonScrollBottom(buttonScrollBottom); }, animateTimeHide);
            }
        }
    }
    main.classList.add(CLASS_MOVE);
    setTimeout(function () { return main.classList.remove(CLASS_MOVE); }, animateTimeHide);
    toScroll(scrollState);
}
// скролит страницу на заданную величину
function toScroll(scrollState) {
    scrollElementTo_1.default(window, scrollState, animateTime);
    setTimeout(function () {
        isActiveScroll = false;
    }, animateTime);
}
// инициализация скрипта прокрутки страницы по экранам
function initScroll(main, containerElements, titleAllHeight, navigateMenuContainer, boundDocumentScrollHandler, boundDocumentClickHandler) {
    // Все элементы в ul
    var list = containerElements.children;
    // Номер элемента который не влез
    var numberElementMargin = 0;
    // Позиция элементов от верха
    var positionTop = 0;
    // ППомещается ли элемент в экран
    var isNumberCount = false;
    // Высота экрана с высотами шапки и футера
    var screen = (screenHeight + PADDING_ALL_SCREEN_HEIGHT);
    // Цикл определяющий какой номер элемента не влез и все высоты элементов
    Array.prototype.forEach.call(list, function (item, index) {
        // Высота отступа элемента от верха + высота прокрутки окна + высота прокрутки блока main
        if ((item.getBoundingClientRect().top + window.pageYOffset + main.scrollTop)
            >= (screenHeight - titleAllHeight)
            && !isNumberCount) {
            numberElementMargin = index;
            positionTop = (item.getBoundingClientRect().top + window.pageYOffset + main.scrollTop) - screenHeight;
            isNumberCount = true;
        }
        // Записываю в массив все высоты элементов
        arrayHeightElements.push(item.offsetHeight);
    });
    // Если все элементы влезли, то выходим из функции
    if (numberElementMargin === 0) {
        containerElements.style.height = '';
        main.classList.remove(CLASS_SCREEN);
        return;
    }
    // Вешаю обработчик на колесо мыши
    window.addEventListener('wheel', boundDocumentScrollHandler);
    // console.log(event.target);
    main.classList.add(CLASS_SCREEN);
    // Цикл где расставляется марджин элементам
    for (var i = numberElementMargin; i < list.length; i += numberElementMargin) {
        // Функция сравнения двух высот, возвращает большую высоту
        var compareNumbers = function (a, b) {
            if (b === void 0) { b = 0; }
            if (a >= b) {
                return a;
            }
            else {
                return b;
            }
        };
        // Выделенный элемент
        var currentElement = list[i];
        // Если меньше 2 элементов или 2 помещаются в экран
        if (numberElementMargin <= 2) {
            // Максимальная высота элемента
            var maxHeightElement = arrayHeightElements[i] / 2;
            // Максимальная высота предыдущего элемента
            var maxHeightPrevElement = compareNumbers(arrayHeightElements[i - 1], arrayHeightElements[i - 2]);
            // Верхнее положение предыдущего элемента
            var topPrevElement = 0;
            // Если есть соседний эелемент ( сравниваем с ним ), если нет берём высоту первого
            if (arrayHeightElements[i + 1]) {
                maxHeightElement = compareNumbers(arrayHeightElements[i], arrayHeightElements[i + 1]) / 2;
            }
            // Предыдущий элемент
            if (currentElement.previousElementSibling) {
                topPrevElement = currentElement.previousElementSibling.getBoundingClientRect().top + window.pageYOffset;
            }
            /*currentElement.style.marginTop =
                ( (screenHeight + PADDING_ALL_SCREEN_HEIGHT) / 2)
                - maxHeightElement + screen
                - ( topPrevElement
                    + maxHeightPrevElement - 40
                ) + 'px';*/
            currentElement.style.marginTop =
                (((screenHeight + PADDING_ALL_SCREEN_HEIGHT) / 2)
                    - maxHeightElement + screen
                    - (topPrevElement
                        + maxHeightPrevElement)) -
                    (((screenHeight) / 2) - titleAllHeight - maxHeightElement)
                    + 'px';
            listElementsMargin.push(currentElement);
            // Следующий элемент
            if (currentElement.nextElementSibling) {
                // Следующий элемент
                var nextElement = currentElement.nextElementSibling;
                nextElement.style.marginTop =
                    ((screenHeight + PADDING_ALL_SCREEN_HEIGHT) / 2)
                        - maxHeightElement + screen
                        - (topPrevElement
                            + maxHeightPrevElement) -
                        (((screenHeight) / 2) - titleAllHeight - maxHeightElement)
                        + 'px';
                /*nextElement.style.marginTop =
                    ( (screenHeight + PADDING_ALL_SCREEN_HEIGHT) / 2)
                    - maxHeightElement + screen
                    - ( topPrevElement
                        + maxHeightPrevElement - 40
                    ) + 'px';*/
                listElementsMargin.push(nextElement);
            }
        }
        else {
            // Первый элемент от выбранного
            var nextElementOne = 0;
            // Второй элемент от выбранного
            var nextElementTwo = 0;
            // Третий элемент от выбранного
            var nextElementThree = 0;
            // Четвёртый элемент от выбранного
            var nextElementTwoFourth = 0;
            // Пятый элемент от выбранного
            var nextElementTwoFifth = 0;
            // Шестой элемент от выбранного
            var nextElementTwoSixth = 0;
            // Седьмой элемент от выбранного
            var nextElementTwoSeventh = 0;
            // Максимальная высота элемента
            var maxHeightElement = 0;
            // Максимальная высота следующей первой пары элементов
            var maxHeightNextElement = 0;
            // Максимальная высота следующей второй пары элементов
            var maxHeightFollowingFourthElement = 0;
            // Максимальная высота следующей третьей пары элементов
            var maxHeightFollowingSixthElement = 0;
            // Максимальная высота предыдущей пары элементов
            var maxHeightPrevElement = 0;
            // Верхнее положение предыдущего элемента
            var topPrevElement = 0;
            if (arrayHeightElements[i + 1]) {
                nextElementOne = arrayHeightElements[i + 1];
            }
            if (arrayHeightElements[i + 2]) {
                nextElementTwo = arrayHeightElements[i + 2];
            }
            if (arrayHeightElements[i + 3]) {
                nextElementThree = arrayHeightElements[i + 3];
            }
            if (numberElementMargin >= 6) {
                if (arrayHeightElements[i + 4]) {
                    nextElementTwoFourth = arrayHeightElements[i + 4];
                }
                if (arrayHeightElements[i + 5]) {
                    nextElementTwoFifth = arrayHeightElements[i + 5];
                }
                maxHeightFollowingFourthElement = (compareNumbers(nextElementTwoFourth, nextElementTwoFifth) / 2);
            }
            if (numberElementMargin >= 8) {
                if (arrayHeightElements[i + 6]) {
                    nextElementTwoSixth = arrayHeightElements[i + 6];
                }
                if (arrayHeightElements[i + 7]) {
                    nextElementTwoSeventh = arrayHeightElements[i + 7];
                }
                maxHeightFollowingSixthElement = (compareNumbers(nextElementTwoFourth, nextElementTwoFifth) / 2);
            }
            maxHeightElement = (compareNumbers(arrayHeightElements[i], nextElementOne) / 2);
            maxHeightNextElement = (compareNumbers(nextElementTwo, nextElementThree) / 2);
            maxHeightPrevElement = (compareNumbers(arrayHeightElements[i - 1], arrayHeightElements[i - 2]));
            topPrevElement = (list[i - 1].getBoundingClientRect().top + window.pageYOffset);
            /*currentElement.style.marginTop =
                ( (screenHeight + PADDING_ALL_SCREEN_HEIGHT ) / 2 )
                - ( maxHeightElement + maxHeightNextElement + maxHeightFollowingFourthElement
                + maxHeightFollowingSixthElement ) + screen
                - ( topPrevElement + maxHeightPrevElement ) + 'px';*/
            currentElement.style.marginTop =
                (((screenHeight + PADDING_ALL_SCREEN_HEIGHT) / 2)
                    - (maxHeightElement + maxHeightNextElement + maxHeightFollowingFourthElement
                        + maxHeightFollowingSixthElement) + screen
                    - (topPrevElement + maxHeightPrevElement)) -
                    (((screenHeight) / 2) - titleAllHeight -
                        (maxHeightElement + maxHeightNextElement +
                            maxHeightFollowingFourthElement + maxHeightFollowingSixthElement))
                    + 'px';
            listElementsMargin.push(currentElement);
            if (list[i + 1]) {
                var nextElement = list[i + 1];
                /*nextElement.style.marginTop =
                    ( ( screenHeight + PADDING_ALL_SCREEN_HEIGHT ) / 2 )
                    - ( maxHeightElement + maxHeightNextElement + maxHeightFollowingFourthElement
                    + maxHeightFollowingSixthElement ) + screen
                    - ( topPrevElement + maxHeightPrevElement ) + 'px';*/
                nextElement.style.marginTop =
                    (((screenHeight + PADDING_ALL_SCREEN_HEIGHT) / 2)
                        - (maxHeightElement + maxHeightNextElement + maxHeightFollowingFourthElement
                            + maxHeightFollowingSixthElement) + screen
                        - (topPrevElement + maxHeightPrevElement)) -
                        (((screenHeight) / 2) - titleAllHeight -
                            (maxHeightElement + maxHeightNextElement +
                                maxHeightFollowingFourthElement + maxHeightFollowingSixthElement))
                        + 'px';
                listElementsMargin.push(nextElement);
            }
        }
        screen = screen + (screenHeight + PADDING_ALL_SCREEN_HEIGHT);
    }
    screenCount = Math.ceil(list.length / numberElementMargin);
    heightContainer = (screenCount * (screenHeight + PADDING_ALL_SCREEN_HEIGHT))
        - (document.documentElement.scrollHeight - containerElements.offsetHeight);
    containerElements.style.height = heightContainer + 'px';
    heightElement = heightContainer;
    createdNavigationMenu(main, navigateMenuContainer, screenCount, boundDocumentClickHandler);
}
// Удаление элементов в массиве
function removeChildNavigationMenu(array, container) {
    array.forEach(function (item) {
        container.removeChild(item);
    });
    array.length = 0;
}
// Очищение массива и обнуление отступов
function clearArray() {
    listElementsMargin.forEach(function (item) {
        item.style.marginTop = '';
    });
    listElementsMargin.length = 0;
}
// создание меню навигации
function createdNavigationMenu(main, navigateMenuContainer, countScreenOnPage, boundDocumentClickHandler) {
    for (var i = 0; i < countScreenOnPage; i++) {
        // Создание элемента а
        var bulitElement = document.createElement('a');
        // Создание элемента li
        var bulitElementContainer = document.createElement('li');
        bulitElement.addEventListener('click', function (event) { return targetClick(event, main); });
        arrayNavigationMenuElements.push(bulitElementContainer);
        bulitElementContainer.appendChild(bulitElement);
        navigateMenuContainer.appendChild(bulitElementContainer);
    }
    // Создание элемента button ( кнопки прокрутки вниз )
    var button = document.createElement('button');
    button.classList.add('scroll-bottom');
    button.textContent = 'Показать ещё';
    button.addEventListener('click', boundDocumentClickHandler);
    buttonScrollBottom = button;
    var parentNavigateMenuContainer = navigateMenuContainer.closest('aside.navigation');
    parentNavigateMenuContainer.appendChild(buttonScrollBottom);
    return navigateMenuContainer;
}
// Добавление класса кнопки прокрутки вниз
function addClassButtonScrollBottom(button) {
    button.classList.add('hide');
}
// Удаление класса кнопки прокрутки вниз
function removeClassButtonScrollBottom(button) {
    button.classList.remove('hide');
}
// Очистка высоты у ul
function clearHeightContainer(containerElements) {
    containerElements.style.height = '';
}
function installScrollHeight(containerElements) {
    if (!isModeMobile()) {
        if (heightElement !== 0) {
            var test_1 = 0;
            containerElements.style.height = heightElement + 'px';
            arrayNavigationMenuElements.some(function (item, index) {
                if (item.classList.contains(CLASS_CURRENT)) {
                    test_1 = index;
                    return true;
                }
                return false;
            });
            var rezult = test_1 * document.documentElement.clientHeight;
            scrollElementTo_1.default(window, rezult, 10);
        }
    }
}
function isModeMobile() {
    return (window.innerWidth < SCREEN_WIDTH_SMALL);
}

},{"../../lib/utils/animation/scrollElementTo":22,"../../lib/utils/events/debounce":23}],12:[function(require,module,exports){
"use strict";
var CLASS_FOCUSED = 'focused';
function main() {
    var form = document.querySelector('header>div.container>div.scroll>form.search');
    if (!form) {
        return;
    }
    var inputSearch = form.querySelector('input');
    // const query = window.location.search;
    // const value = query.match(/[^\=]+$/);
    if (inputSearch.value) {
        // inputSearch.value = decodeURIComponent(value[0]);
        toggleClass(form, true, inputSearch);
    }
    registerHandlers(form, inputSearch);
}
exports.default = main;
function registerHandlers(form, inputSearch) {
    inputSearch.addEventListener('focus', function () { return toggleClass(form, true, inputSearch); });
    inputSearch.addEventListener('blur', function () { return toggleClass(form, false, inputSearch); });
    form.addEventListener('submit', function (event) { return reuireForm(inputSearch, event); });
}
function toggleClass(form, bool, inputSearch) {
    var value = inputSearch.value;
    if (bool === true) {
        form.classList.add(CLASS_FOCUSED);
    }
    else {
        if (value === '') {
            form.classList.remove(CLASS_FOCUSED);
        }
    }
}
function reuireForm(input, event) {
    if (input.value === '') {
        event.preventDefault();
    }
}

},{}],13:[function(require,module,exports){
"use strict";
var calcHeight_1 = require('./calcHeight');
function main() {
    var slidesCollection = document.querySelectorAll('main.index>div.second-screen>div.second-slideshow>ul.slides>li');
    if (slidesCollection.length) {
        calcHeight_1.default(slidesCollection);
        window.addEventListener('resize', function () { return calcHeight_1.default(slidesCollection); });
    }
}
exports.default = main;

},{"./calcHeight":5}],14:[function(require,module,exports){
"use strict";
var CLASS_CURRENT = 'current';
function main() {
    var container = document.querySelector('main.vacancies');
    if (!container) {
        return;
    }
    var form = container.querySelector('form');
    if (!form) {
        return;
    }
    var aside = form.querySelector('aside.success');
    form.addEventListener('submit', function (event) {
        event.preventDefault();
        ajaxLoad(form, aside);
    });
}
exports.default = main;
function ajaxLoad(form, aside) {
    var request = new XMLHttpRequest();
    var data = new FormData(form);
    request.open(form.method, form.action, true);
    request.addEventListener('load', show);
    request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    request.send(data);
    function show() {
        if ((request.readyState === XMLHttpRequest.DONE)
            && (request.status === 200)) {
            aside.classList.add(CLASS_CURRENT);
            form.reset();
        }
        else {
            alert('Сообщение не отправлено, попробуйте снова.');
        }
    }
}

},{}],15:[function(require,module,exports){
"use strict";
// import ShowLightbox from '../classes/ShowLightbox';
var ShowFadeLightbox_1 = require('../classes/ShowFadeLightbox');
var scrollElementTo_1 = require('../../lib/utils/animation/scrollElementTo');
/** Обозначение кнопки esc */
var VK_ESC = 27;
var SCREEN_WIDTH_SMALL = 980;
var isOpenedLightbox = false;
var scrollState = 0;
function main() {
    var container = document.querySelector('main.vacancies');
    if (!container) {
        return;
    }
    var listElementsContainer = container.querySelector('ul.vacancies');
    if (!listElementsContainer) {
        return;
    }
    var controls = container.querySelector('div.controls');
    var buttonClose = controls.querySelector('button.close');
    var showFadeLightbox;
    var unRegisterHandlers;
    if (listElementsContainer.children.length > 0) {
        showFadeLightbox = new ShowFadeLightbox_1.default(listElementsContainer.children, controls);
    }
    /** Клик мимо */
    var boundDocumentClickHandler = function (event) {
        if (event.target.classList.contains('lightbox')) {
            event.stopPropagation();
            closeLightbox(showFadeLightbox, unRegisterHandlers);
        }
    };
    /** нажатие esc */
    var boundDocumentKeyupHandler = function (event) {
        if (event.keyCode === VK_ESC) {
            closeLightbox(showFadeLightbox, unRegisterHandlers);
        }
    };
    unRegisterHandlers = function () {
        document.removeEventListener('click', boundDocumentClickHandler, true);
        document.removeEventListener('keyup', boundDocumentKeyupHandler, true);
    };
    buttonClose.addEventListener('click', function (event) {
        event.stopPropagation();
        closeLightbox(showFadeLightbox, unRegisterHandlers);
    });
    Array.prototype.forEach.call(listElementsContainer.children, function (item, index) {
        registerHandlersLightbox(showFadeLightbox, item, index, boundDocumentClickHandler, boundDocumentKeyupHandler);
    });
    // Событие по закрытию лайтбокса
    listElementsContainer.addEventListener('ShowLightbox:close', function () {
        installScrollHeight();
    });
}
exports.default = main;
function registerHandlersLightbox(showFadeLightbox, item, index, handlerClick, handlerEsc) {
    var asideId = item.querySelector('aside').id;
    item.addEventListener('click', function () {
        openLightbox(showFadeLightbox, index, handlerClick, handlerEsc);
    });
    if (window.location.hash === "#" + asideId) {
        openLightbox(showFadeLightbox, index, handlerClick, handlerEsc);
    }
}
/** открыть лайтбокс */
function openLightbox(lightbox, index, handlerClick, handlerEsc) {
    if (!isOpenedLightbox) {
        scrollState = window.pageYOffset;
        lightbox.open(index);
        document.addEventListener('click', handlerClick, true);
        document.addEventListener('keyup', handlerEsc, true);
        isOpenedLightbox = true;
    }
}
/** закрыть лайтбокс */
function closeLightbox(lightbox, unRegisterHandlers) {
    if (isOpenedLightbox) {
        lightbox.close();
        unRegisterHandlers();
        window.location.hash = '';
        isOpenedLightbox = false;
    }
}
function installScrollHeight() {
    if (isModeMobile()) {
        scrollElementTo_1.default(window, scrollState, 10);
    }
}
function isModeMobile() {
    return (window.innerWidth < SCREEN_WIDTH_SMALL);
}

},{"../../lib/utils/animation/scrollElementTo":22,"../classes/ShowFadeLightbox":2}],16:[function(require,module,exports){
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Map_1 = require('./Map');
/**/
var CLASS_MARKER = 'marker';
Map_1.default.registerPlugin('InfoBox', function () { return (function (_super) {
    __extends(InfoBox, _super);
    function InfoBox(options) {
        _super.call(this);
        this.setDefault();
        if (options) {
            this.setOptions(options);
        }
    }
    /*public constructor( name: string )
    {
        super();
        console.log( this, name );
    }*/
    InfoBox.prototype.sayHello = function () {
        //console.log( 'Hello!' );
    };
    InfoBox.prototype.getContent = function () {
        return this.options.content;
    };
    InfoBox.prototype.getPosition = function () {
        return this.options.position;
    };
    InfoBox.prototype.getZIndex = function () {
        return this.options.zIndex;
    };
    InfoBox.prototype.setContent = function (content) {
        this.options.content = content;
    };
    InfoBox.prototype.setPosition = function (position) {
        this.options.position = position;
    };
    InfoBox.prototype.setZIndex = function (zIndex) {
        this.options.zIndex = zIndex;
    };
    InfoBox.prototype.setTextAlign = function (textAlign) {
        this.textAlign = textAlign;
    };
    InfoBox.prototype.setOffsetTop = function (offset) {
        this.offsetTop = offset;
    };
    InfoBox.prototype.addClass = function (className) {
        this.element.classList.add(className);
    };
    InfoBox.prototype.removeClass = function (className) {
        this.element.classList.remove(className);
    };
    InfoBox.prototype.hasClass = function (className) {
        return this.element.classList.contains(className);
    };
    InfoBox.prototype.onAdd = function () {
        var panes;
        panes = this.getPanes();
        if (!panes) {
            return;
        }
        if (!this.element) {
            this.create();
        }
        panes.floatPane.appendChild(this.element);
        this.size = new google.maps.Size(this.element.offsetWidth, this.element.offsetHeight);
        this.ltMargin = new google.maps.Size(parseInt(this.element.style.marginLeft), parseInt(this.element.style.marginTop));
        if (!this.options.disableAutoPan) {
            this.panMap();
        }
        //super.onAdd();
    };
    InfoBox.prototype.draw = function () {
        var pixelPosition;
        pixelPosition = this.getProjection().fromLatLngToDivPixel(this.options.position);
        if (!pixelPosition) {
            return;
        }
        if (this.options.pixelOffset === null) {
            this.options.pixelOffset = new google.maps.Size(0, 0);
        }
        //this.element.style.top = ( pixelPosition.y - this.options.pixelOffset.height - this.size.height * 1.5 ).toString() + 'px';
        this.element.style.top = (pixelPosition.y - this.options.pixelOffset.height - this.size.height * 1.5 - this.offsetTop).toString() + 'px';
        this.element.style.left = (pixelPosition.x + this.options.pixelOffset.width - this.size.width / 2).toString() + 'px';
        this.element.style.textAlign = this.textAlign;
        //super.draw();
    };
    InfoBox.prototype.onRemove = function () {
        this.element.remove();
    };
    InfoBox.prototype.open = function (map, anchor) {
        if (anchor) {
            if (anchor instanceof google.maps.Marker) {
                this.isMarker = true;
                if (typeof anchor.getPosition === "function") {
                    this.options.position = anchor.getPosition();
                }
            }
            else if (anchor instanceof google.maps.LatLng) {
                this.options.position = anchor;
            }
            else {
                this.options.position = null;
            }
        }
        if (this.options.position instanceof google.maps.LatLng) {
            this.setMap(map);
        }
    };
    InfoBox.prototype.close = function () {
        this.setMap(null);
    };
    InfoBox.prototype.setDefault = function () {
        this.options = {};
        this.options.content = '';
        this.options.disableAutoPan = false;
        this.options.maxWidth = 0;
        this.options.pixelOffset = null;
        this.options.position = null;
        this.options.zIndex = 0;
        this.element = null;
        this.size = null;
        this.ltMargin = null;
        this.textAlign = 'left';
        this.offsetTop = 0;
        this.isMarker = false;
    };
    InfoBox.prototype.setOptions = function (options) {
        //var key: any;
        //
        //for ( key in options )
        //{
        //if ( options.hasOwnProperty( key ) )
        //{
        //if ( options[key] )
        //{
        //console.log( 'key: ' + key + ', options[key]: ' + options[key] );
        //this.options[key] = options[key];
        //}
        //}
        //}
        if (options.content) {
            this.options.content = options.content;
        }
        if (options.disableAutoPan) {
            this.options.disableAutoPan = options.disableAutoPan;
        }
        if (options.maxWidth) {
            this.options.maxWidth = options.maxWidth;
        }
        if (options.pixelOffset) {
            this.options.pixelOffset = options.pixelOffset;
        }
        if (options.position) {
            this.options.position = options.position;
        }
        if (options.zIndex) {
            this.options.zIndex = options.zIndex;
        }
    };
    InfoBox.prototype.create = function () {
        if (!this.element) {
            var element;
            var content;
            element = document.createElement('div');
            element.classList.add('info-box');
            element.addEventListener('click', this.elementClickHandler.bind(this), false);
            if (!this.isMarker) {
                var close;
                close = document.createElement('button');
                close.classList.add('close');
                close.type = 'button';
                element.appendChild(close);
                close.addEventListener('click', this.buttonCloseClickHandler.bind(this), false);
            }
            content = document.createElement('div');
            content.classList.add('content');
            element.appendChild(content);
            document.addEventListener('keyup', this.documentKeyupHandler.bind(this), false);
            //document.addEventListener( 'keyup.infobox', this.documentKeyupHandler, false );
            if (this.options.maxWidth > 0) {
                element.style.maxWidth = this.options.maxWidth.toString() + 'px';
            }
            if (this.options.zIndex !== 0) {
                element.style.zIndex = this.options.zIndex.toString();
            }
            element.addEventListener('mousedown', this.elementMouseDownHandler.bind(this), false);
            this.element = element;
            content.innerHTML = this.options.content.toString();
            if (this.isMarker) {
                this.addClass(CLASS_MARKER);
            }
        }
    };
    InfoBox.prototype.panMap = function () {
        var map;
        var bounds;
        var margin;
        var mapElement;
        var boundsSpan;
        var degPixelX;
        var degPixelY;
        var position;
        var pixelOffset;
        var boxWestLng;
        var boxEastLng;
        var boxNorthLat;
        var boxSouthLat;
        var mapWestLng;
        var mapEastLng;
        var mapNorthLat;
        var mapSouthLat;
        var shiftLng;
        var shiftLat;
        var center;
        map = _super.prototype.getMap.call(this);
        if (!map || !this.element) {
            return;
        }
        bounds = map.getBounds();
        if (!bounds) {
            return;
        }
        margin = 20;
        mapElement = map.getDiv();
        boundsSpan = bounds.toSpan();
        degPixelX = boundsSpan.lng() / mapElement.offsetWidth;
        degPixelY = boundsSpan.lat() / mapElement.offsetHeight;
        if (this.options.pixelOffset === null) {
            this.options.pixelOffset = new google.maps.Size(0, 0);
        }
        position = this.options.position;
        pixelOffset = this.options.pixelOffset;
        boxWestLng = position.lng() + (pixelOffset.width + this.ltMargin.width - margin)
            * degPixelX;
        boxEastLng = position.lng() + (pixelOffset.width + this.ltMargin.width + this.size.width + margin)
            * degPixelX;
        boxNorthLat = position.lat() + (pixelOffset.height - this.ltMargin.height + this.size.height + margin)
            * degPixelY;
        boxSouthLat = position.lat() + (pixelOffset.height - this.ltMargin.height - margin)
            * degPixelY;
        mapWestLng = bounds.getSouthWest().lng();
        mapEastLng = bounds.getNorthEast().lng();
        mapNorthLat = bounds.getNorthEast().lat();
        mapSouthLat = bounds.getSouthWest().lat();
        shiftLng = (boxWestLng < mapWestLng ? mapWestLng - boxWestLng : 0)
            + (boxEastLng > mapEastLng ? mapEastLng - boxEastLng : 0);
        shiftLat = (boxNorthLat > mapNorthLat ? mapNorthLat - boxNorthLat : 0)
            + (boxSouthLat < mapSouthLat ? mapSouthLat - boxSouthLat : 0);
        center = map.getCenter();
        map.setCenter(new google.maps.LatLng(center.lat() - shiftLat, center.lng() - shiftLng));
    };
    InfoBox.prototype.documentKeyupHandler = function (event) {
        if (event.which === 27) {
            this.close();
        }
    };
    InfoBox.prototype.elementClickHandler = function (event) {
        event.stopImmediatePropagation();
        event.stopPropagation();
        this.close();
    };
    InfoBox.prototype.elementMouseDownHandler = function (event) {
        event.stopPropagation();
    };
    InfoBox.prototype.buttonCloseClickHandler = function (event) {
        this.close();
    };
    return InfoBox;
}(google.maps.OverlayView)); });

},{"./Map":17}],17:[function(require,module,exports){
/// <reference path="google.maps.d.ts" />
"use strict";
var Map = (function () {
    /**
     * Элемент с картой
     * @param {HTMLElement} element Элемент страницы, в который будет помещена карта
     * @param {MapOptionsCallback?} options Функция, возвращающая параметры карты (опционально)
     * @param {MapInitCallback?} callback Действия после инициализации (опционально)
     */
    function Map(element, options, callback) {
        if (Map.scriptLoaded
            || ((typeof google !== 'undefined')
                && google.maps
                && (typeof google.maps.Map === 'function'))) {
            this.initElement(element, options, callback);
        }
        else {
            Map.initElementCallbacks.push(this.initElement.bind(this, element, options, callback));
            if (!Map.scriptCreated) {
                Map.createMapsScript();
            }
        }
    }
    /**
     * Установить функцию для вызова после инициализации скрипта карт Google
     * @param {FirstInitListener} callback
     */
    Map.addFirstInitListener = function (callback) {
        if (Map.scriptLoaded) {
            callback();
        }
        Map.firstInitListeners.push(callback);
    };
    /**
     * Зарегистрировать новый дополнительный модуль
     * @param {Function} name
     * @param {string} initializer
     */
    Map.registerPlugin = function (name, initializer) {
        Map.addFirstInitListener(function () { return Map.plugins[name] = initializer(); });
    };
    /**
     * Запросить дополнительный модуль
     * @param {string} name
     * @returns {T}
     */
    Map.plugin = function (name) {
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest[_i - 1] = arguments[_i];
        }
        return Map.plugins.hasOwnProperty(name)
            ? (typeof Map.plugins[name] === 'function'
                ? new ((_a = Map.plugins[name]).bind.apply(_a, [void 0].concat(rest)))()
                : Map.plugins[name])
            : null;
        var _a;
    };
    /**
     * Инициализировать все зарегистрированные элементы карт
     */
    Map.initAllElements = function () {
        Map.initElementCallbacks.forEach(function (callback) { return callback(); });
    };
    /**
     * Действия после инициализации скрипта карт Google
     */
    Map.onScriptLoaded = function () {
        Map.scriptLoaded = true;
        Map.firstInitListeners.forEach(function (listener) {
            if (typeof listener === 'function') {
                listener();
            }
        });
    };
    /**
     * Подключить к странице скрипт карт Google
     */
    Map.createMapsScript = function () {
        var script;
        var callbackName;
        var lang = document.documentElement.lang;
        Map.scriptCreated = true;
        callbackName = 'initializeMap' + Date.now();
        window[callbackName] = Map.initAllElements;
        script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = "http://maps.googleapis.com/maps/api/js?key=AIzaSyAlo1hlVPWhF_BRdi0ar_BFmE1iVWk3O2o&v=3&language=" + lang + "&callback=" + callbackName;
        document.head.appendChild(script);
    };
    /**
     * Изменить размер карты
     * Если не переданы размеры, сработает как обновление карты под текущие.
     * @param {number?} width Новая ширина (опционально)
     * @param {number?} height Новая высота (опционально)
     */
    Map.prototype.resize = function (width, height) {
        var element;
        element = this.element;
        if (element && element.style) {
            if (width > 0) {
                element.style.width = (width | 0) + 'px';
            }
            if (height > 0) {
                element.style.width = (height | 0) + 'px';
            }
        }
        if (this.map) {
            google.maps.event.trigger(this.map, 'resize');
        }
    };
    /**
     * Инициализация элемента
     * @param element
     * @param options
     * @param callback
     */
    Map.prototype.initElement = function (element, options, callback) {
        var googleMapOptions;
        if (!Map.scriptLoaded) {
            Map.onScriptLoaded();
        }
        if (typeof options === 'function') {
            googleMapOptions = options();
        }
        this.map = new google.maps.Map(element, googleMapOptions);
        this.element = element;
        if (typeof callback === 'function') {
            callback(this);
        }
    };
    /**
     * Скрипт карт Google подключён к станице
     */
    Map.scriptCreated = false;
    /**
     * Скрипт карт Google подключён и инициализирован
     */
    Map.scriptLoaded = false;
    /**
     * Функции для вызова после подключения скрипта карт Google
     */
    Map.firstInitListeners = [];
    /**
     * Список функций для инициализации элементов
     */
    Map.initElementCallbacks = [];
    /**
     * Подключённые дополнительные модули
     */
    Map.plugins = {};
    return Map;
}());
exports.default = Map;

},{}],18:[function(require,module,exports){
try {
    new CustomEvent('test');
}
catch (exception) {
    /* tslint:disable:variable-name */
    var MyCustomEvent;
    MyCustomEvent = function (event, params) {
        var eventObject;
        params = params || {
            bubbles: false,
            cancelable: false,
            detail: undefined
        };
        eventObject = document.createEvent('CustomEvent');
        eventObject.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return eventObject;
    };
    MyCustomEvent.prototype = Event.prototype;
    window['CustomEvent'] = MyCustomEvent;
}

},{}],19:[function(require,module,exports){
"use strict";
require('./Element.matches');
if (Element && !Element.prototype.closest) {
    Element.prototype.closest = closest;
}
function closest(selector) {
    var element = this;
    while (element
        && (element.nodeType === Node.ELEMENT_NODE)) {
        if (element.matches(selector)) {
            return element;
        }
        element = element.parentElement;
    }
    return null;
}

},{"./Element.matches":20}],20:[function(require,module,exports){
if (Element && !Element.prototype.matches) {
    main();
}
function main() {
    var proto = Element.prototype;
    proto.matches = proto.matchesSelector
        || proto.mozMatchesSelector
        || proto.msMatchesSelector
        || proto.oMatchesSelector
        || proto.webkitMatchesSelector
        || matches;
}
function matches(selector) {
    var element = this;
    var matches = element.ownerDocument.querySelectorAll(selector);
    var i = matches.length;
    while ((--i >= 0)
        && (matches.item(i) !== element))
        ;
    return i > -1;
}

},{}],21:[function(require,module,exports){
"use strict";
/**
 * Linear - no easing, no acceleration.
 *
 * @param {number} t Time from 0 to 1
 * @returns {number}
 */
function linear(t) {
    return t;
}
exports.linear = linear;
/* ==================================================
 * Quadratic Ease
 */
/**
 * Quadratic Ease in - accelerating from zero velocity.
 *
 * @param {number} t Time from 0 to 1
 * @returns {number}
 */
function quadIn(t) {
    return t * t;
}
exports.quadIn = quadIn;
/**
 * Quadratic Ease out - decelerating to zero velocity.
 *
 * @param {number} t Time from 0 to 1
 * @returns {number}
 */
function quadOut(t) {
    return t * (2 - t);
}
exports.quadOut = quadOut;
/**
 * Quadratic Ease in-out - acceleration until halfway,
 * then deceleration.
 *
 * @param {number} t Time from 0 to 1
 * @returns {number}
 */
function quadInOut(t) {
    return (t < 0.5)
        ? 2 * t * t
        : -1 + (4 - 2 * t) * t;
}
exports.quadInOut = quadInOut;
/* ==================================================
 * Cubic Ease
 */
/**
 * Cubic Ease in - accelerating from zero velocity.
 *
 * @param {number} t Time from 0 to 1
 * @returns {number}
 */
function cubicIn(t) {
    return t * t * t;
}
exports.cubicIn = cubicIn;
/**
 * Cubic Ease out - decelerating to zero velocity.
 *
 * @param {number} t Time from 0 to 1
 * @returns {number}
 */
function cubicOut(t) {
    return (--t) * t * t + 1;
}
exports.cubicOut = cubicOut;
/**
 * Cubic Ease in-out - acceleration until halfway,
 * then deceleration.
 *
 * @param {number} t Time from 0 to 1
 * @returns {number}
 */
function cubicInOut(t) {
    return (t < 0.5)
        ? 4 * t * t * t
        : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
}
exports.cubicInOut = cubicInOut;

},{}],22:[function(require,module,exports){
"use strict";
var Ease = require('./Ease');
/**
 * Плавная прокрутка содержимого элемента до указанной позиции.
 *
 * @param {HTMLElement|Window} element Элемент
 * @param {number} to Позиция прокрутки, в пикселах
 * @param {number} duration Длительность анимации, мс
 * @param {boolean} [horizontal=false] Горизонтальная прокрутка?
 * @param {Ease.EasingFunction} [ease=Ease.quadOut] Функция изменения по времени
 */
function scrollElementTo(element, to, duration, horizontal, ease) {
    if (horizontal === void 0) { horizontal = false; }
    if (ease === void 0) { ease = Ease.quadInOut; }
    if ((duration <= 0)
        || !element) {
        return;
    }
    var startScroll;
    var setScroll;
    if (element instanceof Window) {
        if (horizontal) {
            startScroll = element.pageXOffset;
            setScroll = function (position) {
                return element.scrollTo(position, element.pageYOffset);
            };
        }
        else {
            startScroll = element.pageYOffset;
            setScroll = function (position) {
                return element.scrollTo(element.pageXOffset, position);
            };
        }
    }
    else if (element instanceof HTMLElement) {
        if (horizontal) {
            startScroll = element.scrollLeft;
            setScroll = function (position) {
                return element.scrollLeft = position;
            };
        }
        else {
            startScroll = element.scrollTop;
            setScroll = function (position) {
                return element.scrollTop = position;
            };
        }
    }
    var distance = to - startScroll;
    var startTime = Date.now();
    var tick = function () {
        var time = (Date.now() - startTime) / duration;
        if (time >= 1) {
            setScroll(to);
            return;
        }
        setScroll(startScroll + distance * ease(time) | 0);
        window.requestAnimationFrame(tick);
    };
    tick();
}
exports.default = scrollElementTo;

},{"./Ease":21}],23:[function(require,module,exports){
"use strict";
/**
 * Выполнять функцию не более одного раза,
 * пока не превышен интервал между вызовами
 * @param {Function} func
 * @param {number=100} threshold
 * @param {boolean=false} atBeginning
 * @returns {Function}
 */
function debounce(func, threshold, atBeginning) {
    if (threshold === void 0) { threshold = 100; }
    if (atBeginning === void 0) { atBeginning = false; }
    var timerId;
    return function debounced() {
        var _this = this;
        var rest = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            rest[_i - 0] = arguments[_i];
        }
        if (timerId) {
            clearTimeout(timerId);
        }
        else if (atBeginning) {
            func.apply(this, rest);
        }
        timerId = setTimeout(function () {
            if (!atBeginning) {
                func.apply(_this, rest);
            }
            timerId = 0;
        }, threshold);
    };
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = debounce;

},{}],24:[function(require,module,exports){
"use strict";
/**
 * Выполнять функцию не чаще заданного интервала
 * @param {Function} func
 * @param {number=100} threshold
 * @returns {Function}
 */
function throttle(func, threshold) {
    if (threshold === void 0) { threshold = 100; }
    var timerId;
    var lastExecutionTime;
    return function throttled() {
        var _this = this;
        var rest = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            rest[_i - 0] = arguments[_i];
        }
        var currentTime;
        currentTime = Date.now();
        if (lastExecutionTime
            && (currentTime < lastExecutionTime + threshold)) {
            clearTimeout(timerId);
            timerId = setTimeout(function () {
                lastExecutionTime = currentTime;
                func.apply(_this, rest);
            }, threshold);
        }
        else {
            lastExecutionTime = currentTime;
            func.apply(this, rest);
        }
    };
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = throttle;

},{}]},{},[3])

